<template>
  <div id="top-header">
    <div class="title">
      <h1 class="mt-8 mb-5">{{ title }}</h1>
    </div>
    <div class="desc_container">
      <div class="subtitle"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: ['title'],
}
</script>

<style scoped>
.subtitle {
  height: 80px;
  margin: 20px 0;
}

.desc_container {
  background: url('/bg3.jpg');
  background-size: cover;
  opacity: 1;
  height: 200px;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  /* Aligns the slot content to the top */
}
</style>
